import React from "react";
import { Card } from "@/components/ui/card";

export function hoursLabel(value) {
    return `${Number(value || 0).toFixed(2)}h`;
}

export function PayrollMetricCard({ icon: Icon, label, value }) {
    return (
        <Card className="p-3">
            <div className="flex items-center gap-2 text-xs text-muted-foreground"><Icon className="w-3.5 h-3.5" />{label}</div>
            <div className="text-xl font-bold mt-1">{value}</div>
        </Card>
    );
}

export function PayrollSummaryField({ label, value }) {
    return (
        <div className="rounded-lg border p-3">
            <div className="tiny-label">{label}</div>
            <div className="mt-1">{value || "-"}</div>
        </div>
    );
}

export function PayrollTh({ children }) {
    return <th className="px-3 py-2 text-left whitespace-nowrap">{children}</th>;
}

export function PayrollTd({ children, className = "", colSpan }) {
    return <td colSpan={colSpan} className={`px-3 py-2 whitespace-nowrap ${className}`}>{children}</td>;
}